import { InfrastructureError } from '@goodt-wcore/errors';

export class AuthAdapterError extends InfrastructureError {
    constructor(...args) {
        super(...args);
        this.name = 'AuthAdapterError';
    }
}
